import { shallowRef as a, ref as u, computed as i } from "vue";
import { useResizeObserver as n } from "./index562.js";
import { MINIMUM_INPUT_WIDTH as c } from "./index696.js";
function p() {
  const t = a(), e = u(0), r = i(() => ({
    minWidth: `${Math.max(e.value, c)}px`
  }));
  return n(t, () => {
    var l, o;
    e.value = (o = (l = t.value) == null ? void 0 : l.getBoundingClientRect().width) != null ? o : 0;
  }), {
    calculatorRef: t,
    calculatorWidth: e,
    inputStyle: r
  };
}
export {
  p as useCalcInputWidth
};
